import { render, staticRenderFns } from "./PriceTime.vue?vue&type=template&id=0ec7ae08"
import script from "./PriceTime.vue?vue&type=script&lang=js"
export * from "./PriceTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports